__turbopack_context__.v({
  "root": "fieldset-module__JP5PSW__root",
});
